<template>
  <div class="base-display">
    <img :src="require('@/assets/daping/base.svg')" class="base-img" />
    <div
      :class="[
        'base-data'
      ]"
    >
      <div v-for="(item, index) in baseDataList" :key="index" class="list">
        <img :src="item.img" class="base-data-img" />
        <div class="name-num">
          <div class="name">{{ item.name }}</div>
          <div class="num">{{ item.num }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import titleInternal from "@/pages/patrolScreenMini/components/title-internal.vue";
export default {
  name: "index",
  components: {
    titleInternal,
  },
  props: {
    baseDataList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isPadding: {
      type: String,
      default: "",
    },
    titleName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.base-display {
  display: flex;
  align-items: center;
  position: relative;
  // margin: 20px 0 0 10px;
  .base-img {
    width: 322px;
    position: absolute;
    top: 50px;
  }
  .base-data {
    display: flex;
    width: 322px;
    padding: 0 10px;
    margin-top: 10px;
    .list {
      display: flex;
      width: 33.3%;
      .name-num {
        margin: 0 0 0 8px;
      }
      .name {
        font-family: MiSans, MiSans;
        font-weight: 400;
        font-size: 12px;
        color: #adc2d3;
        line-height: 22px;
      }
      .num {
        font-family: MiSans, MiSans;
        font-weight: 500;
        font-size: 16px;
        color: #e4f2ff;
        line-height: 22px;
      }
    }
    .base-data-img {
      width: 24px;
      height: 25px;
    }
  }
  .base-data-three {
    padding: 0 20px;
    .list {
      width: 33.3%;
    }
  }
  .analysisDisposal {
    width: 420px;
  }
  .isPaddingOne {
    .list {
      width: 28.3%;
    }
    .list:last-child {
      width: 20%;
    }
  }
  .isPaddingTwo {
    padding: 0 0 0 20px;
    .list {
      width: 28.3%;
    }
    .list:last-child {
      width: 20%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/patrolScreenMini/components/base-display.vue